import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=bc1ff328&scoped=true&"
var script = {}
import style0 from "./404Page.vue?vue&type=style&index=0&id=bc1ff328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ff328",
  null
  
)

export default component.exports